<template src="./register.html"></template>

<script>

import {API_URL} from '@/main'
import axios from "axios"
import router from '@/router/index.js'

export default {
  name: "RegisterPassword",
  data() {
    return {
      acceptance: false,
      email: '',
      exception: '',
      login: '',
      name: '',
      password: '',
      registration_executed: false,
      showAlertAcceptance: false,
      showAlertRegistration: false,
      showAlertConfirmationError: false,
      showAlertGenericError: false,
    }
  },
  mounted() {
  },
  methods: {
    async execute_confirm() {

      const url = API_URL+"login/Register/"
      const data = {
        confirmation_code: this.confirmation_code,
      }
      const response = await axios.post(url, data)
      
      if(response.data.message == "Activation done") {

        router.push({path: "/"})
      }
      else if (response.data.message == "Code returned is wrong") {

        this.showAlertConfirmationError = true
      }
      else if (response.data.message.startsWith("Exception:")) {

        this.exception = response.data.message.slice("Exception:".length)
        this.showAlertGenericError = true
      }
    },
    async execute_register() {
      
      try {

        if(this.acceptance == false) {

          this.showAlertAcceptance = true
        }
        else {

          let privacy = 0
          if(this.acceptance == true) {

            privacy = 1
          }

          const url = API_URL+"login/RegisterDetail/"
          const data = {
            privacy: privacy,
            email: this.email,
            username: this.login,
            first_name: this.name,
            password: this.password,
            active: false,
          }
          const response = await axios.post(url, data)

          if(response.data.message == "User registered successfully") {

            this.showAlertRegistration = true
            this.registration_executed = true
          }
        }
      }
      catch (error) {
 
         console.debug('Error during registration:', error)
      }
    },
    goto_login() {

      router.push({path: "/"})
    }
  },
}

</script>

<style>
.custom-alert .close {
  position: absolute;
  right: 1rem;
  color: #fff;
  background-color: rgba(255, 255, 255, 0);
  color: black;
  border: 0;
  padding: 0.2rem 0.6rem;
  opacity: 1;
  transition: background-color 0.3s, color 0.3s;
}

</style>